{
  "name": "meble-pro",
  "version": "1.0.0",
  "private": true,
  "packageManager": "npm@11.12.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:staging": "ng build --configuration=staging --no-progress",
    "build:production": "ng build --configuration=production --no-progress",
    "lint": "eslint --color -c .eslint.config.js --ext .ts ./src/app",
    "test": "ng test",
    "test:ci": "ng test --watch=false",
    "prepare": "husky"
  },
  "lint-staged": {
    "src/app/**/*.{ts,html}": [
      "eslint --color -c .eslint.precommit.config.js --fix ./src/app"
    ],
    "**/*.{ts,scss,html}": [
      "prettier --write"
    ]
  },
  "dependencies": {
    "@angular/common": "^22.2.0",
    "@angular/compiler": "^22.2.0",
    "@angular/core": "^22.2.0",
    "@angular/forms": "^22.2.0",
    "@angular/material": "^21.2.1",
    "@angular/platform-browser": "^22.2.0",
    "@angular/platform-browser-dynamic": "^22.2.0",
    "@angular/platform-server": "^22.2.0",
    "@angular/router": "^22.2.0",
    "@angular/ssr": "^22.2.0",
    "express": "^5.2.1",
    "husky": "^9.1.7",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^22.5.0",
    "@angular-eslint/eslint-plugin-template": "^22.5.0",
    "@angular-eslint/template-parser": "^22.5.0",
    "@angular/build": "^22.2.0",
    "@angular/cli": "^22.2.0",
    "@angular/compiler-cli": "^22.2.0",
    "@eslint/eslintrc": "^3.3.7",
    "@eslint/js": "^10.0.1",
    "@types/express": "^5.0.6",
    "@types/node": "^25.0.3",
    "@typescript-eslint/eslint-plugin": "^8.71.0",
    "@typescript-eslint/parser": "^8.71.0",
    "eslint": "^10.0.2",
    "eslint-plugin-diff": "^2.1.7",
    "eslint-plugin-rxjs-x": "^1.0.6",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.1.1",
    "lint-staged": "^17.6.0",
    "prettier": "^3.9.9",
    "typescript": "~6.0.3",
    "vitest": "^5.0.0"
  }
}
